import type {Group} from 'three'

import type {MonaCanvasFaceDirection} from '../types'
import type MainMona from './main-mona'

export function updateOpeningGaze(mona: MainMona, direction: MonaCanvasFaceDirection, lookAt: Group, delta: number) {
  mona.updateRestingPose(delta)
  lookAt.lookAt(direction.x, direction.y, direction.z)
  mona.group.quaternion.premultiply(lookAt.quaternion)
}
